import { BookingManager } from "./booking/BookingManager";
import { IBookingItem } from "./booking/model/BookingData";
import { IBookingOptions } from "./booking/model/BookingData";

export function create(containerId: string = "booking", bookedData: IBookingItem[] = [], options: IBookingOptions = {})
{
    return new BookingManager(containerId, bookedData, options);
}
